import type { LicenseItem } from '~/types/master-data';

interface MapLicenseItem extends LicenseItem {
  children?: MapLicenseItem[];
}

export function mapNestedLicenses(licenses: LicenseItem[]) {
  const licenseMap = new Map<number, MapLicenseItem>();
  const nestedLicenses: MapLicenseItem[] = [];

  // 資格をIDごとにマップに格納
  licenses.forEach((license) => {
    // 親の場合のみchildrenを設定
    if (license.license_id === null) {
      licenseMap.set(license.id, { ...license, children: [] });
    } else {
      licenseMap.set(license.id, { ...license });
    }
  });

  // 親子関係を構築
  licenses.forEach((license) => {
    if (license.license_id === null) {
      // 親資格の場合
      nestedLicenses.push(licenseMap.get(license.id)!);
    } else {
      // 子資格の場合
      const parent = licenseMap.get(license.license_id);
      if (parent) {
        parent.children?.push(licenseMap.get(license.id)!);
      }
    }
  });

  return nestedLicenses;
}
